var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 305,
    viewBox: "0 0 1440 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1613.73 305L1613.73 -7.51792e-06M1561.12 305L1561.12 -1.21173e-05M1508.51 305L1508.51 -1.67167e-05M1455.9 305L1455.9 -2.13162e-05M1403.29 305L1403.29 -2.59156e-05M1350.68 305L1350.68 -3.0515e-05M1298.06 305L1298.06 -3.51144e-05M1245.45 305L1245.45 -3.97138e-05M1192.84 305L1192.84 -4.43132e-05M1140.23 305L1140.23 -4.89126e-05M1087.62 305L1087.62 -5.3512e-05M1035.01 305L1035.01 -5.81114e-05M982.398 305L982.398 -6.27108e-05M929.787 305L929.787 -6.73102e-05M877.176 305L877.176 -7.19097e-05M824.565 305L824.565 -7.65091e-05M771.953 305L771.953 -8.11085e-05M719.342 305L719.342 -8.57079e-05M666.731 305L666.731 -9.03073e-05M614.12 305L614.12 -9.49067e-05M561.509 305L561.509 -9.95061e-05M508.898 305L508.898 -0.000104106M456.287 305L456.287 -0.000108705M403.676 305L403.676 -0.000113304M351.065 305L351.065 -0.000117904M298.453 305L298.453 -0.000122503M245.842 305L245.842 -0.000127103M193.231 305L193.231 -0.000131702M140.62 305L140.62 -0.000136301M88.009 305L88.009 -0.000140901M35.3979 305L35.3979 -0.0001455M-17.2132 305L-17.2132 -0.0001501M-69.8244 305L-69.8243 -0.000154699M-122.435 305L-122.435 -0.000159298M-175.047 305L-175.047 -0.000163898M-227 251.756L1667 251.757M-227 199.17L1667 199.17M-227 146.584L1667 146.584M-227 93.9977L1667 93.998M-227 41.4115L1667 41.4118",
    stroke: "url(#paint0_linear_657_3266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_3266",
    x1: 720,
    y1: 316.5,
    x2: 720,
    y2: -0.0000886336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539408,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584198,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.8a5b331e4220fa4c7f060437767b9803.svg";
export { ForwardRef as ReactComponent };